import React, { useMemo, useState } from 'react';
import { Animated, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import { DemoModal } from '@/components/Home/DemoModal';
import { Icon } from '@/components/Icon';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { Text } from '@/components/Text';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';
import { useOnHover } from '@/hooks/useOnHover';
import { isPatientApp } from '@/config/constants';
import store, { useStoreState } from '@/stores/store';

import { styles } from './styles';
import colors from '@/config/colors';
import { useTherapistDemo } from '@/contexts/TherapistDemoContext';

export const AccountMenuItem = ({
  labelOpacity,
  labelTranslateX,
}: {
  labelOpacity: Animated.AnimatedInterpolation<string | number>;
  labelTranslateX: Animated.AnimatedInterpolation<string | number>;
}) => {
  const [logoutFromDemo, setLogoutFromDemo] = useState(false);
  const [showDemoPopUp, setShowDemoPopUp] = useState<boolean>(false);
  const [demoTimerCounter, setDemoCounterTimer] =
    useState<NodeJS.Timeout | null>(null);
  const { isTherapistDemo } = useStoreState((store) => store);
  const { user } = store.getState()?.signedInUser;
  const { appTitle } = useSidebarAnimation();
  const { navigate } =
    useNavigation<StackNavigationProp<TherapistStackParamList>>();
  const { toggleDemoLogout } = useTherapistDemo();
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();
  const isSelected = useMemo(() => {
    return appTitle === 'Benutzerkonto';
  }, [appTitle]);

  return (
    <>
      <PressableNeolexon
        onPress={() =>
          isTherapistDemo ? toggleDemoLogout() : navigate('Account')
        }
        onHoverIn={handleHoverIn}
        onHoverOut={handleHoverOut}
        style={[
          { paddingVertical: 8 },
          isHovered && { opacity: 0.5 },
          isSelected && styles.isSelected,
        ]}
      >
        <View
          style={[styles.menuItemContainer, isSelected && { paddingLeft: 4 }]}
        >
          <Icon
            name={isTherapistDemo ? 'logout' : 'accountCircle'}
            size={28}
            color={colors.newUI.therapist.primaryBlue80}
          />
          <Animated.View
            style={[
              {
                opacity: labelOpacity,
                transform: [{ translateX: labelTranslateX }],
              },
            ]}
          >
            {isTherapistDemo ? (
              <Text style={{ paddingLeft: 15, fontWeight: 600 }}>
                Demo beenden
              </Text>
            ) : (
              <>
                <Text style={{ paddingLeft: 15, fontWeight: 600 }}>
                  {user?.firstName} {user?.lastName}
                </Text>
                <Text style={{ paddingLeft: 15, fontSize: 12 }}>
                  {isPatientApp ? 'Patient:in' : 'Therapeut:in'}
                </Text>
              </>
            )}
          </Animated.View>
        </View>
      </PressableNeolexon>
    </>
  );
};
